import { Component, OnInit, Inject } from '@angular/core';
import { TelPostServicioComponent } from 'app/components/tablas/apoyo-usuario/tel-post-servicio/tel-post-servicio.component';
import { InfoBeneficiarioComponent } from 'app/components/tablas/apoyo-usuario/info-beneficiario/info-beneficiario.component';
import { BitacoraInfoBenefComponent } from 'app/components/tablas/apoyo-usuario/bitacora-info-benef/bitacora-info-benef.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-informacion',
  templateUrl: './informacion.component.html',
  styleUrls: ['./informacion.component.scss']
})
export class InformacionComponent implements OnInit {

  public beneficiario_doc: string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos) { }

  ngOnInit() {
    this.beneficiario_doc = this.datos;
  }

}
